import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-use-flow-page',
  templateUrl: './use-flow-page.component.html',
  styleUrls: ['./use-flow-page.component.scss'],
})
export class UseFlowPageComponent implements OnInit {
  url: any;

  constructor(
    private router: Router,
    private message: MessageService
  ) {
  }

  ngOnInit(): void {
    this.url = this.router.url.split('?')[0];
  }

  download() {
    window.open('https://www.yunlogin.com/download');
  }

  temp() {
    this.message.open('该功能尚未开通');
  }
}
